import styled from "styled-components";
import Text from "../../Text";

export const StyledErrorMessage = styled(Text)`
    line-height: 1;
    color: ${(props) => props.theme.colors.error.strong};
    font-size: ${(props) => props.theme.elements.form.input.fontSizeError};
    margin-top: 10px;
`;
